import { BlocksAnchorNav } from 'blocks-nextjs/blocks-web-components/components/anchor-nav/anchor-nav';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatAnchorNav = createComponent({ react: React, tagName: 'cat-anchor-nav', elementClass: BlocksAnchorNav });
